var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 16 0)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h12a2 2 0 012 2v16a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z",
    fill: "#E09B53"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 1.488,
    y: 1.707,
    width: 13.395,
    height: 9.809,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0h.44C3.956 0 5.365.786 6.16 2.076l.043.07a4.52 4.52 0 003.846 2.146H16V18a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z",
    fill: "#F6B26A"
  }))));
}
export default SvgFolderSmall;